export function supportsState(): boolean {
    return !!window.history.pushState;
}
interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
